import React, { PureComponent } from "react";
import Popup from "./Popup.js";
import Button from "../Button/Button.js";
import Constants from '../Constants.js';

// Font Awesome
import { library } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrophy } from '@fortawesome/free-solid-svg-icons';
import { faTwitter, faFacebook } from '@fortawesome/free-brands-svg-icons';
library.add(faTrophy);
library.add(faTwitter);
library.add(faFacebook);



class PopupRateApp extends PureComponent {

    constructor(props) {
        super(props);
        this.show = this.show.bind(this);
        this.hide = this.hide.bind(this);
        this.popup = React.createRef();
    }

    show() {
        this.popup.current.show();
    }
    hide() {
        this.popup.current.hide();
    }

    render() {

        return (
            <Popup
                ref={this.popup}
                showing={false}
            >
                <h1 className="Title">
                    Congratulations!
                </h1>
                <div className="Wrapper">
                    <FontAwesomeIcon
                        className="TrophyIcon"
                        icon="trophy"
                    />
                </div>
                <p className="Paragraph">
                    You've beaten every level! Keep an eye out for more levels in the near future. In the meantime, show off your accomplishment to your friends on social media?
                </p>
                <a href={Constants.twitterShareLink} target="_blank" rel="noopener noreferrer">
                    <Button
                        activeColor={'#fff'}
                        inactiveColor={'#38A1F3'}
                        borderColor={'#38A1F3'}
                        onClick={() => {
                        }}
                    >
                        <FontAwesomeIcon className="ButtonIcon" icon={faTwitter} />
                        Tweet
                    </Button>
                </a>
                <a href={Constants.facebookShareLink} target="_blank" rel="noopener noreferrer">
                    <Button
                        activeColor={'#fff'}
                        inactiveColor={'#1777F2'}
                        borderColor={'#1777F2'}
                        onClick={() => {
                        }}
                    >
                        <FontAwesomeIcon className="ButtonIcon" icon={faFacebook} />
                        Share
                    </Button>
                </a>
            </Popup>
        );
    }
}

export default PopupRateApp;
